/*eslint no-undef:0, no-unused-vars:0*/

// this is some special webpack magic to figure out the directory for
// require.ensure() statements and gets re-written during the compile phase
// to the actual variable used inside the webpack universe
// see: http://webpack.github.io/docs/api-in-modules.html#__webpack_public_path__

__webpack_public_path__ = document.body.getAttribute('data-js-path') + '/apps/';




//////////////////
// WEBPACK FOOTER
// ./lib/webpack-setup.js
// module id = 26
// module chunks = 0